import { useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useStore } from 'context/store-context';

export const SwitchStore = ({
  canSwitchStore = true,
}: {
  canSwitchStore?: boolean;
}) => {
  const { storeId: requestedStoreId } = useParams();
  const { storeId, userStores, isLoading, updateUserStore } = useStore();
  const navigate = useNavigate();
  const committedStore = useRef<string | null>(null);
  const target = userStores?.find(
    (store) => store.storeId === requestedStoreId,
  );

  useEffect(() => {
    if (
      !canSwitchStore ||
      isLoading ||
      !target ||
      !updateUserStore ||
      committedStore.current === target.storeId
    )
      return;
    committedStore.current = target.storeId;
    // This route is reached only after the previous page's navigation guard.
    if (storeId !== target.storeId) updateUserStore(target);
    navigate('/', { replace: true });
  }, [canSwitchStore, isLoading, target, updateUserStore, storeId, navigate]);

  const error = !canSwitchStore
    ? 'Store switching is unavailable in this workspace.'
    : isLoading
    ? null
    : !updateUserStore
    ? 'Store switching is unavailable in this workspace.'
    : !target
    ? 'This store is not available to your account.'
    : null;

  return (
    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      {error ? (
        <>
          <p role="alert" className="text-sm text-gray-700">
            {error}
          </p>
          <Link
            to="/"
            className="mt-3 inline-block text-sm text-blue-700 hover:underline"
          >
            Back to Home
          </Link>
        </>
      ) : (
        <p role="status" className="text-sm text-gray-500">
          {isLoading ? 'Loading stores…' : 'Switching store…'}
        </p>
      )}
    </div>
  );
};
